export default {
    API_LOGIN: '/service/centralize-authenticate/api/tenant/v1/auth/login',
    API_LOGOUT: '/service/centralize-authenticate/api/tenant/v1/auth/logout',
    API_REFRESH_TOKEN: 'service/centralize-authenticate/api/tenant/v1/auth/token/refresh',
    API_AUTH_CONTEXT: 'service/centralize-authenticate/api/tenant/v1/auth/context',
    API_PROFILE: 'service/centralize-authenticate/api/tenant/v1/profile',
    API_FORGOT_PASSWORD: 'service/centralize-authenticate/api/tenant/v1/auth/forgot-password',
    API_RESET_PASSWORD: 'service/centralize-authenticate/api/tenant/v1/auth/reset-password',
    API_CHECK_RESET_TOKEN: 'service/centralize-authenticate/api/tenant/v1/auth/reset-token/check',
    API_CONFIG: 'service/centralize-authenticate/api/tenant/v1/config',
}
